import { GridApi, ColumnState } from "ag-grid-enterprise";

export const applyGridColumnState = (api: GridApi, keyName?: string, options?: { delay?: number }) => {
  const delay = options?.delay || 50;

  setTimeout(() => {
    if (!api || (api as GridApi).isDestroyed?.()) return;
    const colDefs = api.getColumnDefs() ?? [];
    const liveColIds = colDefs.map((c: any) => c.colId || c.field);
    const columnSavedState = localStorage.getItem(`${keyName}_COLUMNS_STATE`);
    const savedState: ColumnState[] = columnSavedState ? JSON.parse(columnSavedState) : [];
    const savedMap = new Map(savedState.map((s) => [s.colId, s]));
    const finalState: ColumnState[] = [];
    for (const s of savedState) {
      if (liveColIds.includes(s.colId)) finalState.push(s);
    }
    for (const colId of liveColIds) {
      if (!savedMap.has(colId)) {
        const indexInDefs = liveColIds.indexOf(colId);
        finalState.splice(indexInDefs, 0, { colId });
      }
    }
    const seen = new Set();
    const cleanedState = finalState.filter((s) => {
      if (seen.has(s.colId)) return false;
      seen.add(s.colId);
      return true;
    });

    api.applyColumnState({
      state: cleanedState,
      applyOrder: true
    });
      if (!columnSavedState) {
          const autoSizeColIds = api
              .getAllGridColumns()
              .filter((col) => {
                  const def = col.getColDef();
                  return !def.width;
              })
              .map((col) => col.getColId());
          const isEmpty = api.getDisplayedRowCount() === 0;
          if (autoSizeColIds.length > 0) {
              api.autoSizeColumns(autoSizeColIds, !isEmpty);
          } else {
              api.autoSizeAllColumns(!isEmpty);
          }
      }
  }, delay);
};
